<template>
  <span
    class="breadcrumb__item"
  >
    <span
      :class="{'breadcrumb__item--clickable' : clickable}"
      @click="$emit('click')"
    >
      {{ text }}
    </span>
    <span class="breadcrumb__item--divider" :class="{'is-multiple-leveled-item': isMultipleLeveledItem}">/</span>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    isMultipleLeveledItem: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.breadcrumb__item {
  @apply font-medium text-xs tracking-widest text-base-80 list-none;
  &:last-child .breadcrumb__item--divider {
    &:not(.is-multiple-leveled-item) {
      @apply hidden;
    }
  }
}

.breadcrumb__item--clickable {
  @apply cursor-pointer hover:underline;
}

.breadcrumb__item--divider {
  @apply px-1;
}
</style>
